import { call, put } from 'redux-saga/effects';
import { ActionType } from 'deox';

import { verifyEmailAction } from '@/redux/actions/company';
import { verifyEmail, TVerifyEmailResponse } from '@/services/api/company';
import { handleAPIError } from '@/utils/handle-api-error';

// FUNCTION - ENDPOINT IS NOT BEING USED
export function* verifyEmailSaga(action: ActionType<typeof verifyEmailAction.request>): Generator {
  const { materials, successCallback, failedCallback } = action.payload;
  try {
    const response = yield call(verifyEmail, materials);
    const verifyEmailResponse: TVerifyEmailResponse = response as TVerifyEmailResponse;
    yield put(verifyEmailAction.success(verifyEmailResponse));
    successCallback?.(verifyEmailResponse);
    handleAPIError(response, 'Success.verifySuccess');
  } catch (err) {
    yield put(verifyEmailAction.failure(err));
    failedCallback?.(err);
    handleAPIError(err, 'Error.verifyOTPWithCompanyEmailError');
  }
}
